module.exports = __webpack_public_path__ + "img/horizontal.9630f8ab.svg";